import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from './api.service';
import { HttpClientModule } from '@angular/common/http';
import { LoggerServiceModule } from '../logger/logger.module';
import { LocalStorageServiceModule } from '../local-storage/local-storage.module';

@NgModule({
	declarations: [],
	imports: [ CommonModule, HttpClientModule, LoggerServiceModule, LocalStorageServiceModule ],
	exports: [],
	providers: [ApiService]
})
export class ApiServiceModule {}
